<div [formGroup]="form" class="detail-right-column">
   @if (showCards) {
   <ndt-card [title]="'General Information'" class="detail-card-half">
      <ng-container *ngTemplateOutlet="generalInfoFields"></ng-container>
   </ndt-card>
   } @else {
   <mat-form-field class="flex-half">
      <mat-label>Extension Number</mat-label>
      <input
         matInput
         autocomplete="off"
         type="number"
         [value]="extension?.number"
         [formControl]="parentFormGroup.get('number')"
         required
         id="a548a982-17d2-4bee-9fa9-e2df166087e7"
      />
      @if (parentFormGroup.get('number')?.hasError('required')) {
      <mat-error> Number Field is Required. </mat-error>
      } @if (parentFormGroup.get('number')?.hasError('pattern')) {
      <mat-error> Invalid Number Format </mat-error>
      } @if (parentFormGroup.get('number')?.hasError('min') || parentFormGroup.get('number')?.hasError('max')) {
      <mat-error> Number must be between 100-99999. </mat-error>
      } @if (parentFormGroup.get('number')?.hasError('extensionAlreadyExists')) {
      <mat-error> Extension number already in use. </mat-error>
      }
   </mat-form-field>
   <mat-form-field class="flex-half">
      <mat-label>Name</mat-label>
      <input
         matInput
         autocomplete="off"
         type="text"
         [value]="extension?.name"
         [formControl]="parentFormGroup.get('name')"
         required
         id="31ebd3f9-980e-4a68-b05d-0d3d768c2d4c"
      />
      @if (parentFormGroup.get('name')?.hasError('required')) {
      <mat-error> Name Field is Required. </mat-error>
      } @if ( !parentFormGroup.get('name')?.hasError('required') && parentFormGroup.get('name')?.hasError('noContent') )
      {
      <mat-error> Name must contain characters. </mat-error>
      }
   </mat-form-field>
   <mat-form-field class="flex-half">
      <mat-label>Short Name</mat-label>
      <input
         matInput
         autocomplete="off"
         type="text"
         [value]="extension?.shortName"
         [formControl]="parentFormGroup.get('shortName')"
         id="f0645680-8615-49ea-af6f-3c55cd8a5dcc"
      />
      @if (parentFormGroup.get('shortName')?.hasError('pattern')) {
      <mat-error> Short Name cannot be greater than 20 characters. </mat-error>
      }
   </mat-form-field>
   <mat-form-field class="flex-half">
      <mat-label>Display Name</mat-label>
      <input
         matInput
         autocomplete="off"
         type="text"
         [value]="extensionPhone?.displayName"
         formControlName="displayName"
         required
         id="cc944ff8-4c72-44b6-a31b-f03f697af8e1"
      />
      @if (form.get('displayName')?.hasError('required')) {
      <mat-error> Display Name is Required. </mat-error>
      } @if (!form.get('displayName')?.hasError('required') && form.get('displayName')?.hasError('noContent')) {
      <mat-error> Display Name must contain characters. </mat-error>
      }
   </mat-form-field>
   }
   <ng-template #generalInfoFields>
      <mat-form-field class="flex-half">
         <mat-label>Extension Number</mat-label>
         <input
            matInput
            autocomplete="off"
            type="number"
            [value]="extension?.number"
            [formControl]="parentFormGroup.get('number')"
            required
            id="a548a982-17d2-4bee-9fa9-e2df166087e7"
         />
         @if (parentFormGroup.get('number')?.hasError('required')) {
         <mat-error> Number Field is Required. </mat-error>
         } @if (parentFormGroup.get('number')?.hasError('pattern')) {
         <mat-error> Invalid Number Format </mat-error>
         } @if (parentFormGroup.get('number')?.hasError('min') || parentFormGroup.get('number')?.hasError('max')) {
         <mat-error> Number must be between 100-99999. </mat-error>
         } @if (parentFormGroup.get('number')?.hasError('extensionAlreadyExists')) {
         <mat-error> Extension number already in use. </mat-error>
         }
      </mat-form-field>
      <mat-form-field class="flex-half">
         <mat-label>Name</mat-label>
         <input
            matInput
            autocomplete="off"
            type="text"
            [value]="extension?.name"
            [formControl]="parentFormGroup.get('name')"
            required
            id="31ebd3f9-980e-4a68-b05d-0d3d768c2d4c"
         />
         @if (parentFormGroup.get('name')?.hasError('required')) {
         <mat-error> Name Field is Required. </mat-error>
         } @if ( !parentFormGroup.get('name')?.hasError('required') &&
         parentFormGroup.get('name')?.hasError('noContent') ) {
         <mat-error> Name must contain characters. </mat-error>
         }
      </mat-form-field>
      <mat-form-field class="flex-half">
         <mat-label>Short Name</mat-label>
         <input
            matInput
            autocomplete="off"
            type="text"
            [value]="extension?.shortName"
            [formControl]="parentFormGroup.get('shortName')"
            id="f0645680-8615-49ea-af6f-3c55cd8a5dcc"
         />
         @if (parentFormGroup.get('shortName')?.hasError('pattern')) {
         <mat-error> Short Name cannot be greater than 20 characters. </mat-error>
         }
      </mat-form-field>
      <mat-form-field class="flex-half">
         <mat-label>Display Name</mat-label>
         <input
            matInput
            autocomplete="off"
            type="text"
            [value]="extensionPhone?.displayName"
            formControlName="displayName"
            required
            id="cc944ff8-4c72-44b6-a31b-f03f697af8e1"
         />
         @if (form.get('displayName')?.hasError('required')) {
         <mat-error> Display Name is Required. </mat-error>
         } @if (!form.get('displayName')?.hasError('required') && form.get('displayName')?.hasError('noContent')) {
         <mat-error> Display Name must contain characters. </mat-error>
         }
      </mat-form-field>
   </ng-template>

   @if (showCards) {
   <ndt-card [title]="'Notes'" class="detail-card-half">
      <ng-container *ngTemplateOutlet="notesFields"></ng-container>
   </ndt-card>
   }
   <ng-template #notesFields>
      @if (isSystemUser) {
      <mat-form-field class="flex-half">
         <mat-label>Admin Notes</mat-label>
         <textarea
            matInput
            #adminNotesArea
            [formControl]="parentFormGroup.get('adminNotes')"
            id="extension-phone-admin-notes"
            style="resize: vertical"
         ></textarea>
      </mat-form-field>
      }
      <mat-form-field
         [ngClass]="{ 'flex-full': !isSystemUser, 'flex-half': isSystemUser, 'readonly-notes': isSystemUser }"
      >
         <mat-label>Extension Notes</mat-label>
         <textarea
            matInput
            #extensionNotesArea
            [formControl]="parentFormGroup.get('extensionNotes')"
            id="extension-phone-notes"
            [readonly]="isSystemUser"
            style="resize: vertical"
         ></textarea>
      </mat-form-field>
   </ng-template>

   @if (showCards) {
   <ndt-card [title]="'Other Information'" class="detail-card-half">
      <ng-container *ngTemplateOutlet="otherFields"></ng-container>
   </ndt-card>
   } @else { @if (extensionPhone) {
   <mat-form-field class="flex-full">
      <mat-label>Office</mat-label>
      <input
         matInput
         [value]="extensionPhone?.office"
         formControlName="office"
         id="extension-phone-dnd-status"
         type="text"
      />
      @if (form.get('office')?.hasError('noContent')) {
      <mat-error> Office must contain characters. </mat-error>
      }@if (form.get('office')?.hasError('maxlength')) {
      <mat-error> Office cannot contain more than 255 characters. </mat-error>
      }
   </mat-form-field>
   } @if (extension?.extensionPhone) {
   <ndt-department-chip-input
      class="flex-full"
      [formControl]="parentFormGroup.get('departmentExtensions')"
      [accountId]="extension?.account?.accountId"
      [extensionId]="extension?.extensionId"
      [formDisabled]="!extensionPrivileges?.canEditDepartmentExtensions || !extensionPrivileges.canEditPhones"
      [canCreateDepartments]="departmentPrivileges?.canAdd && departmentPrivileges?.canEdit"
   ></ndt-department-chip-input>
   } }
   <ng-template #otherFields>
      @if (extensionPhone) {
      <mat-form-field class="flex-full">
         <mat-label>Office</mat-label>
         <input
            matInput
            [value]="extensionPhone?.office"
            formControlName="office"
            id="extension-phone-dnd-status"
            type="text"
         />
         @if (form.get('office')?.hasError('noContent')) {
         <mat-error> Office must contain characters. </mat-error>
         }@if (form.get('office')?.hasError('maxlength')) {
         <mat-error> Office cannot contain more than 255 characters. </mat-error>
         }
      </mat-form-field>
      } @if (extension?.extensionPhone) {
      <ndt-department-chip-input
         class="flex-full"
         [formControl]="parentFormGroup.get('departmentExtensions')"
         [accountId]="extension?.account?.accountId"
         [extensionId]="extension?.extensionId"
         [formDisabled]="!extensionPrivileges?.canEditDepartmentExtensions || !extensionPrivileges.canEditPhones"
         [canCreateDepartments]="departmentPrivileges?.canAdd && departmentPrivileges?.canEdit"
      ></ndt-department-chip-input>
      }
   </ng-template>

   @if (showCards) {
   <ndt-card [title]="'Settings'" class="detail-card-half">
      <ng-container *ngTemplateOutlet="settingFields"></ng-container>
   </ndt-card>
   } @else {
   <mat-form-field class="flex-half field-padding-right">
      <mat-label>Default Area Code</mat-label>
      <input matInput autocomplete="off" type="number" formControlName="defaultAreaCode" id="defaultAreaCode" />
      @if ( form.get('defaultAreaCode')?.hasError('invalidAreaCode') || form.get('defaultAreaCode')?.hasError('numeric')
      || form.get('defaultAreaCode')?.hasError('specialcharacters') || form.get('defaultAreaCode')?.hasError('max') ||
      form.get('defaultAreaCode')?.hasError('required') ) {
      <mat-error> Please enter a valid area code. </mat-error>
      }
   </mat-form-field>
   <mat-form-field class="flex-half field-padding-right">
      <mat-label>Ring Timeout</mat-label>
      <input
         matInput
         autocomplete="off"
         type="number"
         [value]="extensionPhone?.ringTimeout"
         formControlName="ringTimeout"
         required
         id="3f92899c-db93-47b1-9bc9-26b1a96fe601"
      />
      @if (form.get('ringTimeout')?.hasError('required')) {
      <mat-error> Ring Timeout Field is Required. </mat-error>
      } @if (form.get('ringTimeout')?.hasError('min') || form.get('ringTimeout')?.hasError('max')) {
      <mat-error> Number must be between 0-59. </mat-error>
      } @if (form.get('ringTimeout')?.hasError('notInteger')) {
      <mat-error> Number must be an integer. </mat-error>
      }
   </mat-form-field>
   <mat-form-field class="flex-half">
      <mat-label>Default Phone Number</mat-label>
      <input
         [lcsSingleSelect]="phoneNumberSelect"
         [accountId]="accountId"
         ndtPhoneNumberSelect
         autocomplete="off"
         type="text"
         formControlName="defaultPhoneNumber"
         id="extension-phone-default-phone-number"
      />
      <ndt-phone-number-select
         #phoneNumberSelect
         [isIncludeEmptyOption]="true"
         [onlyAllowOutboundCallsNumbers]="true"
      ></ndt-phone-number-select>
   </mat-form-field>
   @if (accountId) {
   <mat-form-field class="flex-half">
      <mat-label>Location</mat-label>
      <input
         autocomplete="off"
         type="text"
         [lcsSingleSelect]="locationSelect"
         ndtLocationSelect
         [accountId]="accountId"
         [formControl]="parentFormGroup.get('location')"
         id="location"
      />
      <ndt-location-select #locationSelect isIncludeEmptyOption="true"></ndt-location-select>
   </mat-form-field>
   }
   <mat-form-field class="flex-half">
      <mat-label>Time Zone</mat-label>
      <input
         class="empty-option-placeholder"
         [lcsSingleSelect]="timeZoneSelect"
         ndtTimeZoneSelect
         autocomplete="off"
         type="text"
         [formControl]="parentFormGroup.get('timeZone')"
         id="extension-phone-time-zone"
         [placeholder]="
            'Use Location/Account Time Zone - (' +
            (parentFormGroup.get('location')?.value?.timeZoneId ?? extension?.account?.timeZoneId ?? timeZoneId) +
            ')'
         "
      />
      <ndt-time-zone-select
         #timeZoneSelect
         isIncludeEmptyOption="true"
         [overrideEmptyOption]="
            'Use Location/Account Time Zone - (' +
            (parentFormGroup.get('location')?.value?.timeZoneId ?? extension?.account?.timeZoneId ?? timeZoneId) +
            ')'
         "
      ></ndt-time-zone-select>
   </mat-form-field>
   }
   <ng-template #settingFields>
      <mat-form-field class="flex-half field-padding-right">
         <mat-label>Default Area Code</mat-label>
         <input matInput autocomplete="off" type="number" formControlName="defaultAreaCode" id="defaultAreaCode" />
         @if ( form.get('defaultAreaCode')?.hasError('invalidAreaCode') ||
         form.get('defaultAreaCode')?.hasError('numeric') || form.get('defaultAreaCode')?.hasError('specialcharacters')
         || form.get('defaultAreaCode')?.hasError('max') || form.get('defaultAreaCode')?.hasError('required') ) {
         <mat-error> Please enter a valid area code. </mat-error>
         }
      </mat-form-field>
      <mat-form-field class="flex-half field-padding-right">
         <mat-label>Ring Timeout</mat-label>
         <input
            matInput
            autocomplete="off"
            type="number"
            [value]="extensionPhone?.ringTimeout"
            formControlName="ringTimeout"
            required
            id="3f92899c-db93-47b1-9bc9-26b1a96fe601"
         />
         @if (form.get('ringTimeout')?.hasError('required')) {
         <mat-error> Ring Timeout Field is Required. </mat-error>
         } @if (form.get('ringTimeout')?.hasError('min') || form.get('ringTimeout')?.hasError('max')) {
         <mat-error> Number must be between 0-59. </mat-error>
         } @if (form.get('ringTimeout')?.hasError('notInteger')) {
         <mat-error> Number must be an integer. </mat-error>
         }
      </mat-form-field>
      <mat-form-field class="flex-half">
         <mat-label>Default Phone Number</mat-label>
         <input
            [lcsSingleSelect]="phoneNumberSelect"
            [accountId]="accountId"
            ndtPhoneNumberSelect
            autocomplete="off"
            type="text"
            formControlName="defaultPhoneNumber"
            id="extension-phone-default-phone-number"
         />
         <ndt-phone-number-select
            #phoneNumberSelect
            [isIncludeEmptyOption]="true"
            [onlyAllowOutboundCallsNumbers]="true"
         ></ndt-phone-number-select>
      </mat-form-field>
      @if (accountId) {
      <mat-form-field class="flex-half">
         <mat-label>Location</mat-label>
         <input
            autocomplete="off"
            type="text"
            [lcsSingleSelect]="locationSelect"
            ndtLocationSelect
            [accountId]="accountId"
            [formControl]="parentFormGroup.get('location')"
            id="location"
         />
         <ndt-location-select #locationSelect isIncludeEmptyOption="true"></ndt-location-select>
      </mat-form-field>
      }
      <mat-form-field class="flex-half">
         <mat-label>Time Zone</mat-label>
         <input
            class="empty-option-placeholder"
            [lcsSingleSelect]="timeZoneSelect"
            ndtTimeZoneSelect
            autocomplete="off"
            type="text"
            [formControl]="parentFormGroup.get('timeZone')"
            id="extension-phone-time-zone"
            [placeholder]="
               'Use Location/Account Time Zone - (' +
               (parentFormGroup.get('location')?.value?.timeZoneId ?? extension?.account?.timeZoneId ?? timeZoneId) +
               ')'
            "
         />
         <ndt-time-zone-select
            #timeZoneSelect
            isIncludeEmptyOption="true"
            [overrideEmptyOption]="
               'Use Location/Account Time Zone - (' +
               (parentFormGroup.get('location')?.value?.timeZoneId ?? extension?.account?.timeZoneId ?? timeZoneId) +
               ')'
            "
         ></ndt-time-zone-select>
      </mat-form-field>
   </ng-template>

   @if (showCards) {
   <ndt-card [title]="'Routing'" class="detail-card-half">
      <ng-container *ngTemplateOutlet="routingFields"></ng-container>
   </ndt-card>
   } @else {
   <mat-form-field class="flex-half field-padding-right">
      <mat-label>Route Busy Extension</mat-label>
      <input
         class="empty-option-placeholder"
         [lcsSingleSelect]="routeBusyExtensionSelect"
         [accountId]="accountId"
         ndtExtensionSelect
         autocomplete="off"
         type="text"
         formControlName="routeBusyExtension"
         id="extension-phone-route-busy-extension"
         [extensionTypesToExclude]="[7]"
      />
      <ndt-extension-select
         #routeBusyExtensionSelect
         [nullActionsToInclude]="nullActions"
         [excludedIds]="[extensionId]"
      ></ndt-extension-select>
   </mat-form-field>
   <mat-form-field class="flex-half">
      <mat-label>Route No Answer Extension</mat-label>
      <input
         class="empty-option-placeholder"
         [lcsSingleSelect]="routeNoAnswerExtensionSelect"
         [accountId]="accountId"
         ndtExtensionSelect
         autocomplete="off"
         type="text"
         formControlName="routeNoAnswerExtension"
         id="extension-phone-route-no-answer-extension"
         [extensionTypesToExclude]="[7]"
      />
      <ndt-extension-select
         #routeNoAnswerExtensionSelect
         [nullActionsToInclude]="nullActions"
         [excludedIds]="[extensionId]"
      ></ndt-extension-select>
   </mat-form-field>
   <mat-checkbox
      class="flex-full"
      [checked]="canForwardCalls"
      [disabled]="!canEdit"
      id="canForwardCalls"
      (change)="onCanForwardCallsChange($event)"
      >Forward Calls</mat-checkbox
   >
   <div class="feature-chip-input">
      @if (canForwardCalls) {
      <ndt-extension-and-external-numbers-chip-input
         [extensions]="extension?.account?.extensionsConnection?.items || extensions"
         [externalNumbers]="externalNumbers"
         formControlName="forwardCalls"
         [extensionIdsToExclude]="extensionIdsToExclude"
         [maxChipCount]="1"
         [required]="canForwardCalls"
         [touched]="form.get('forwardCalls').touched"
         chipLabel="Phone Number/Extension"
      ></ndt-extension-and-external-numbers-chip-input>
      }
   </div>
   }
   <ng-template #routingFields>
      <mat-form-field class="flex-half field-padding-right">
         <mat-label>Route Busy Extension</mat-label>
         <input
            class="empty-option-placeholder"
            [lcsSingleSelect]="routeBusyExtensionSelect"
            [accountId]="accountId"
            ndtExtensionSelect
            autocomplete="off"
            type="text"
            formControlName="routeBusyExtension"
            id="extension-phone-route-busy-extension"
            [extensionTypesToExclude]="[7]"
         />
         <ndt-extension-select
            #routeBusyExtensionSelect
            [nullActionsToInclude]="nullActions"
            [excludedIds]="[extensionId]"
         ></ndt-extension-select>
      </mat-form-field>
      <mat-form-field class="flex-half">
         <mat-label>Route No Answer Extension</mat-label>
         <input
            class="empty-option-placeholder"
            [lcsSingleSelect]="routeNoAnswerExtensionSelect"
            [accountId]="accountId"
            ndtExtensionSelect
            autocomplete="off"
            type="text"
            formControlName="routeNoAnswerExtension"
            id="extension-phone-route-no-answer-extension"
            [extensionTypesToExclude]="[7]"
         />
         <ndt-extension-select
            #routeNoAnswerExtensionSelect
            [nullActionsToInclude]="nullActions"
            [excludedIds]="[extensionId]"
         ></ndt-extension-select>
      </mat-form-field>
      <mat-checkbox
         class="flex-full"
         [checked]="canForwardCalls"
         [disabled]="!canEdit"
         id="canForwardCalls"
         (change)="onCanForwardCallsChange($event)"
         >Forward Calls</mat-checkbox
      >
      <div class="feature-chip-input">
         @if (canForwardCalls) {
         <ndt-extension-and-external-numbers-chip-input
            [extensions]="extension?.account?.extensionsConnection?.items || extensions"
            [externalNumbers]="externalNumbers"
            formControlName="forwardCalls"
            [extensionIdsToExclude]="extensionIdsToExclude"
            [maxChipCount]="1"
            [required]="canForwardCalls"
            [touched]="form.get('forwardCalls').touched"
            chipLabel="Phone Number/Extension"
         ></ndt-extension-and-external-numbers-chip-input>
         }
      </div>
   </ng-template>

   @if (showCards) {
   <ndt-card [title]="'Features'" class="detail-card-half">
      <ng-container *ngTemplateOutlet="featureFields"></ng-container>
   </ndt-card>
   } @else { @if (accountIsCallRecordingFeatureEnabled) {
   <mat-checkbox class="flex-full" id="isOtrEnabled" formControlName="isOtrEnabled">
      Enable One-Touch Recording
   </mat-checkbox>
   }
   <mat-checkbox class="flex-full" formControlName="isInNameDirectory" id="isInNameDirectory">
      Include in Name Directory
   </mat-checkbox>
   <mat-checkbox class="flex-full" id="isAutoAnswerEnabled" formControlName="isAutoAnswerEnabled">
      Auto-Answer Calls
   </mat-checkbox>
   <div class="feature-chip-input">
      <ndt-extension-and-group-chip-input
         [extensions]="extension?.account?.extensionsConnection?.items || extensions"
         [extensionGroups]="extension?.account?.extensionGroupsConnection?.items || extensionGroups"
         formControlName="extensionsOrExtensionGroupSupervisees"
         [extensionIdsToExclude]="extensionIdsToExclude"
         [extensionGroupIdsToExclude]=""
         [formDisabled]="!extensionPrivileges.isManageSuperviseesEnabled || !canEdit"
         [titleValue]="'Can Monitor These Extensions'"
      ></ndt-extension-and-group-chip-input>
   </div>
   }
   <ng-template #featureFields>
      @if (accountIsCallRecordingFeatureEnabled) {
      <mat-checkbox class="flex-full" id="isOtrEnabled" formControlName="isOtrEnabled">
         Enable One-Touch Recording
      </mat-checkbox>
      }
      <mat-checkbox class="flex-full" formControlName="isInNameDirectory" id="isInNameDirectory">
         Include in Name Directory
      </mat-checkbox>
      <mat-checkbox class="flex-full" id="isAutoAnswerEnabled" formControlName="isAutoAnswerEnabled">
         Auto-Answer Calls
      </mat-checkbox>
      <div class="feature-chip-input">
         <ndt-extension-and-group-chip-input
            [extensions]="extension?.account?.extensionsConnection?.items || extensions"
            [extensionGroups]="extension?.account?.extensionGroupsConnection?.items || extensionGroups"
            formControlName="extensionsOrExtensionGroupSupervisees"
            [extensionIdsToExclude]="extensionIdsToExclude"
            [extensionGroupIdsToExclude]=""
            [formDisabled]="!extensionPrivileges.isManageSuperviseesEnabled || !canEdit"
            [titleValue]="'Can Monitor These Extensions'"
         ></ndt-extension-and-group-chip-input>
      </div>
   </ng-template>

   @if (showCards) {
   <ndt-card [title]="'Click to Call Settings'" class="detail-card-half">
      <ng-container *ngTemplateOutlet="ringSettingFields"></ng-container>
   </ndt-card>
   } @else {
   <div class="ring-settings-left">
      @if (extensionPhone) {
      <mat-radio-group class="ring-phone-radio-group" formControlName="isRingAllPhones">
         <mat-radio-button color="primary" [value]="true" [checked]="ringAllPhones === true"
            >Ring All Phones</mat-radio-button
         >
         <mat-radio-button color="primary" [value]="false" [checked]="ringAllPhones === false"
            >Ring This Phone</mat-radio-button
         >
      </mat-radio-group>
      }
   </div>
   <div class="ring-settings-right">
      <div class="ring-phone">
         @if (ringAllPhones === false && extensionPhone) {
         <mat-form-field class="flex-full">
            <mat-label>Select Phone *</mat-label>
            <input
               formControlName="autoAnswerPhone"
               autocomplete="off"
               type="text"
               [lcsSingleSelect]="deviceSelect"
               [extensionId]="extensionId"
               ndtPhoneSelect
               id="account-phones"
               [name]="'phone'"
            />
            <ndt-phone-select #deviceSelect></ndt-phone-select>
            @if (form.get('autoAnswerPhone')?.hasError('required')) {
            <mat-error> Phone Field is Required. </mat-error>
            }
         </mat-form-field>
         }
      </div>
      <div class="ring-auto-answer">
         @if (ringAllPhones === false) {
         <mat-checkbox id="isAutoAnswer" formControlName="isAutoAnswer">Auto-Answer </mat-checkbox>
         }
      </div>
   </div>
   }
   <ng-template #ringSettingFields>
      <div class="ring-settings-left">
         @if (extensionPhone) {
         <mat-radio-group class="ring-phone-radio-group" formControlName="isRingAllPhones">
            <mat-radio-button color="primary" [value]="true" [checked]="ringAllPhones === true"
               >Ring All Phones</mat-radio-button
            >
            <mat-radio-button color="primary" [value]="false" [checked]="ringAllPhones === false"
               >Ring This Phone</mat-radio-button
            >
         </mat-radio-group>
         }
      </div>
      <div class="ring-settings-right">
         <div class="ring-phone">
            @if (ringAllPhones === false && extensionPhone) {
            <mat-form-field class="flex-full">
               <mat-label>Select Phone *</mat-label>
               <input
                  formControlName="autoAnswerPhone"
                  autocomplete="off"
                  type="text"
                  [lcsSingleSelect]="deviceSelect"
                  [extensionId]="extensionId"
                  ndtPhoneSelect
                  id="account-phones"
                  [name]="'phone'"
               />
               <ndt-phone-select #deviceSelect></ndt-phone-select>
               @if (form.get('autoAnswerPhone')?.hasError('required')) {
               <mat-error> Phone Field is Required. </mat-error>
               }
            </mat-form-field>
            }
         </div>
         <div class="ring-auto-answer">
            @if (ringAllPhones === false) {
            <mat-checkbox id="isAutoAnswer" formControlName="isAutoAnswer">Auto-Answer </mat-checkbox>
            }
         </div>
      </div>
   </ng-template>

   @if (showCards) {
   <ndt-card [title]="'Door Phone Settings'" class="detail-card-half">
      <ng-container *ngTemplateOutlet="doorPhoneFields"></ng-container>
   </ndt-card>
   } @else {
   <mat-checkbox class="flex-full" [checked]="extensionPhone?.enableDtmf" id="enableDtmf" formControlName="enableDtmf"
      >Play Keys When Answered (Generally Door Bell Extensions)</mat-checkbox
   >
   @if (isDtmfEnabled) {
   <mat-form-field class="flex-half field-padding-right">
      <mat-label>Seconds to Wait</mat-label>
      <input
         matInput
         autocomplete="off"
         type="number"
         formControlName="secondsToWait"
         [value]="extensionPhone?.secondsToWait"
         id="extension-Seconds-to-wait"
         min="0"
         max="20"
      />
      @if (form.get('secondsToWait')?.hasError('required')) {
      <mat-error> Seconds to Wait Field is Required. </mat-error>
      } @if (form.get('secondsToWait')?.hasError('min') || form.get('secondsToWait')?.hasError('max')) {
      <mat-error> Number must be between 0-20. </mat-error>
      } @if (form.get('secondsToWait')?.hasError('notInteger')) {
      <mat-error> Number must be an integer. </mat-error>
      }
   </mat-form-field>
   } @if (isDtmfEnabled) {
   <mat-form-field class="flex-half">
      <mat-label>Keys to Play</mat-label>
      <input
         matInput
         autocomplete="off"
         type="text"
         formControlName="dtmfToPlay"
         [value]="extensionPhone?.dtmfToPlay"
         id="extension-dtmf-to-play"
      />
      @if (form.get('dtmfToPlay')?.hasError('required')) {
      <mat-error> Keys to Play Field is Required. </mat-error>
      } @if (form.get('dtmfToPlay')?.hasError('pattern')) {
      <mat-error> Invalid DTMF Format. </mat-error>
      } @if (form.get('dtmfToPlay')?.hasError('maxlength')) {
      <mat-error> DTMF cannot exceed 10 characters. </mat-error>
      }
   </mat-form-field>
   } }
   <ng-template #doorPhoneFields>
      <mat-checkbox
         class="flex-full"
         [checked]="extensionPhone?.enableDtmf"
         id="enableDtmf"
         formControlName="enableDtmf"
         >Play Keys When Answered (Generally Door Bell Extensions)</mat-checkbox
      >
      @if (isDtmfEnabled) {
      <mat-form-field class="flex-half field-padding-right">
         <mat-label>Seconds to Wait</mat-label>
         <input
            matInput
            autocomplete="off"
            type="number"
            formControlName="secondsToWait"
            [value]="extensionPhone?.secondsToWait"
            id="extension-Seconds-to-wait"
            min="0"
            max="20"
         />
         @if (form.get('secondsToWait')?.hasError('required')) {
         <mat-error> Seconds to Wait Field is Required. </mat-error>
         } @if (form.get('secondsToWait')?.hasError('min') || form.get('secondsToWait')?.hasError('max')) {
         <mat-error> Number must be between 0-20. </mat-error>
         } @if (form.get('secondsToWait')?.hasError('notInteger')) {
         <mat-error> Number must be an integer. </mat-error>
         }
      </mat-form-field>
      } @if (isDtmfEnabled) {
      <mat-form-field class="flex-half">
         <mat-label>Keys to Play</mat-label>
         <input
            matInput
            autocomplete="off"
            type="text"
            formControlName="dtmfToPlay"
            [value]="extensionPhone?.dtmfToPlay"
            id="extension-dtmf-to-play"
         />
         @if (form.get('dtmfToPlay')?.hasError('required')) {
         <mat-error> Keys to Play Field is Required. </mat-error>
         } @if (form.get('dtmfToPlay')?.hasError('pattern')) {
         <mat-error> Invalid DTMF Format. </mat-error>
         } @if (form.get('dtmfToPlay')?.hasError('maxlength')) {
         <mat-error> DTMF cannot exceed 10 characters. </mat-error>
         }
      </mat-form-field>
      }
   </ng-template>
</div>
